import React, { Component, FC, ReactElement } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { Alert } from '@zooplus/ui-components';

import { useConfig } from '../config/ConfigProvider';
import { getSentryService } from '../services/sentryService';

export type SentryErrorBoundaryProps = {
  fallbackRender?: (
    props: FallbackProps,
  ) => ReactElement<unknown, string | FC | typeof Component> | null;
};

/**
 * ErrorBoundary which will send to Sentry all the uncaptured exceptions raised from the given children.
 */
const SentryErrorBoundary: React.FC<SentryErrorBoundaryProps> = ({ children, fallbackRender }) => {
  const { t } = useTranslation();
  const { config } = useConfig();
  const sentry = getSentryService(config.env, config);

  const handleError = (error: Error) => {
    // 1- Simple approach : capture error with no tag
    // ------------------------
    sentry.captureException(error);
    // ------------------------
    // 2- Approach adding a tag
    // ------------------------
    // captureException(error, {
    //   // If you need to send things specific to this error on top of the error
    //   // itself then use this captureContext
    //   captureContext: (scope) => scope.setTags({ type: 'errorBoundary' }),
    // });
    // ------------------------
  };

  const fallbackRenderNullSafe =
    fallbackRender ??
    (() => {
      return (
        <Alert variant="warning">{t('checkout.payment.creditcard.error.method.unavailable')}</Alert>
      );
    });

  return (
    <ErrorBoundary fallbackRender={fallbackRenderNullSafe} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
};

export default SentryErrorBoundary;
